export const parseLLMResponse = message => {
  if (
    message ==
      "I can only answer questions regarding information contained in Council legal memos." ||
    message ==
      'I do not have the necessary information to answer that question.' ||
    message.length < 65
  ) {
    return message;
  }

  const [mainResponseBlock, citationsBlock] = message?.split('**Citations:**');

  // In rare cases, the llm will provide an answer but with no citations block
  if (!citationsBlock) {
    return message;
  }

  // Identify & store inline citations in main response block
  const regex = /<sup>\[?([\d,\s]+)\]?<\/sup>/g;
  let match;
  const unOrderedDupeSuperscripts = [];

  while ((match = regex.exec(mainResponseBlock)) !== null) {
    const numgroup = match[1];
    const numbers = numgroup
      ?.split(',')
      ?.map(n => Number(n.trim()))
      .filter(n => !Number.isNaN(n));
    unOrderedDupeSuperscripts?.push(...numbers);
  }
  // [3, 5, 2, 8, 5] => [2, 3, 5, 5 8]
  unOrderedDupeSuperscripts.sort((a, b) => a - b);

  // [2, 3, 5, 5 8] => {2, 3, 5, 8}
  const dedupedSuperscripts = new Set(unOrderedDupeSuperscripts);
  const normalizedSuperscriptsArr = [...dedupedSuperscripts];

  // Index-reset inline citations in main response block
  const updatedMainResponseBlock = mainResponseBlock?.replace(
    regex,
    (matched_string, num_group) => {
      const nums = num_group
        ?.split(',')
        .map(n => Number(n.trim()))
        .filter(n => !Number.isNaN(n)); // "2, 5, 10" => [2, 5, 10]
      const newNums = [];
      for (const num of nums) {
        if (normalizedSuperscriptsArr.includes(num)) {
          newNums.push(normalizedSuperscriptsArr.indexOf(num) + 1);
        }
      }
      return `<sup>[${newNums.join(', ')}]</sup>`;
    }
  );

  // Identify & store file names in citations block to replace those with clickable links
  const citations = [];
  if (!citationsBlock) return citations;

  const citationLines = citationsBlock?.trim()?.split('\n');

  for (const citationLine of citationLines) {
    // const match = citationLine.match(/<sup>(\d+)<\/sup>\s*(.+)/);
    const match = citationLine.match(/<sup>\[?(\d+)\]?<\/sup>\s*(.+)/);
    if (match) {
      const [, sup, file] = match;
      citations.push({ sup, file: file.trim() });
    }
  }

  // Replace relavant citation's file names with clickable a tags with markdown-safe filenames
  // and remove irrelavant citations/newlines/falsy values
  const updatedCitationsBlock = citations
    .map(citation => {
      const supScriptAsNum = Number(citation.sup);

      if (normalizedSuperscriptsArr.includes(supScriptAsNum)) {
        const escapedFileNameForMarkdown = citation.file.replace(/_/g, '\\_');
        return `<sup>${
          normalizedSuperscriptsArr.indexOf(supScriptAsNum) + 1
        }</sup> <a href="#" class="download-link" data-path="${
          citation.file
        }">${escapedFileNameForMarkdown}</a>`;
      }
      return '';
    })
    .map(line => line.trim())
    .filter(Boolean)
    .join('\n');

  const finalizedLLMResponse =
    updatedMainResponseBlock +
    '**Citations:**\n' +
    updatedCitationsBlock.trimStart();

  return finalizedLLMResponse == '**Citations:**'
    ? message
    : finalizedLLMResponse;
};
